import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment/moment';
import { FormControl, FormGroup } from '@angular/forms';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import { Json2csvService } from 'csvtools-lib';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';

@Component({
  selector: 'app-payments-payments-filter-transactions-card',
  templateUrl: './payments-payments-filter-transactions-card.component.html',
  styleUrls: ['./payments-payments-filter-transactions-card.component.scss']
})
export class PaymentsPaymentsFilterTransactionsCardComponent implements OnInit {

  @Input() data;
  show: boolean;
  refreshing: boolean;
  filterTransactionsForm = new FormGroup({
    dateFrom: new FormControl(),
    dateTo: new FormControl(),
    timeFrom: new FormControl(),
    timeTo: new FormControl()
  });

  constructor(private paymentsService: PaymentsService,
              private dateUnixTrannsformerPipe: DateUnixTransformerPipe,
              private json2csvService: Json2csvService) { }

  ngOnInit() { }

  public showFilter() {
    this.show = !this.show;
  }

  public search() {
    const dateFrom = this.filterTransactionsForm.get('dateFrom').value ? this.filterTransactionsForm.get('dateFrom').value.valueOf() : null;
    const dateTo = this.filterTransactionsForm.get('dateTo').value ? this.filterTransactionsForm.get('dateTo').value.valueOf() : null;
    const timeFrom = (moment(this.filterTransactionsForm.get('timeFrom').value, 'hh:mm').hour() * 3600000) + (moment(this.filterTransactionsForm.get('timeFrom').value, 'hh:mm').minutes() * 60000);
    const timeTo = (moment(this.filterTransactionsForm.get('timeTo').value, 'hh:mm').hour() * 3600000) + (moment(this.filterTransactionsForm.get('timeTo').value, 'hh:mm').minutes() * 60000);
    const from = timeFrom ? dateFrom + timeFrom : dateFrom;
    const to = timeTo ? dateTo + timeTo : dateTo + (23 * 3600000) + (59 * 60000) + (59 * 1000);
    this.paymentsService.refreshTransactions(from , to);
    this.showFilter();
  }

  public clearField(fieldName) {
    this.filterTransactionsForm.patchValue({
      [fieldName]: null
    });
  }

  public generateCSV() {
    this.data.forEach(i => i['datetime'] = this.dateUnixTrannsformerPipe.transform(i['datetime']));
    this.json2csvService.setBody(this.data, ['datetime', 'centerName', 'orderId', 'paymentIdentifier', 'gateway', 'status', 'transactionType', 'bank', 'dataResponse']);
    this.json2csvService.setHeader(['Date', 'Center', 'Order Id', 'payment Id', 'Gateway', 'Status', 'Transaction Type', 'Bank', 'Data']);
    this.json2csvService.generateCSV('transactions');
  }
}
